import { WebsiteContentBlock } from './website-content';

// Policy copy supplied in Privacy Policy_1.docx.
export const privacyPolicy: { title: string; blocks: WebsiteContentBlock[] } = {
    "title": "Privacy policy",
    "blocks": [
        {
            "type": "paragraph",
            "text": "Last updated: 17 October 2026"
        },
        {
            "type": "paragraph",
            "text": "This Privacy Policy explains how Triad Teacher Training collects, uses and protects personal information when you use this website, purchase a digital course, complete learning activities, leave feedback or otherwise contact us."
        },
        {
            "type": "heading",
            "text": "1. Who is responsible for your information"
        },
        {
            "type": "paragraph",
            "text": "Triad Teacher Training is operated by Olha Popivnenko, who is responsible for the personal information processed in connection with the self-study courses provided through this website."
        },
        {
            "type": "paragraph",
            "text": "For privacy enquiries or requests concerning your personal information, please contact:"
        },
        {
            "type": "paragraph",
            "text": "Email: olgapopivnenko35@gmail.com"
        },
        {
            "type": "heading",
            "text": "2. Information we collect"
        },
        {
            "type": "heading",
            "text": "Account information"
        },
        {
            "type": "paragraph",
            "text": "When you create or use an account, we may process:"
        },
        {
            "type": "list",
            "items": [
                "your authentication identifier;",
                "email address;",
                "first and last name;",
                "profile picture, where provided;",
                "account status;",
                "sign-in information, including your most recent sign-in."
            ]
        },
        {
            "type": "paragraph",
            "text": "Some of this information may be provided by the authentication or identity provider you choose to use."
        },
        {
            "type": "heading",
            "text": "Learning information"
        },
        {
            "type": "paragraph",
            "text": "When you use a course, we may process information relating to your learning activity, including:"
        },
        {
            "type": "list",
            "items": [
                "courses and lessons assigned to your account;",
                "lesson openings and completion dates or times;",
                "course progress and completion status;",
                "interactions with learning materials;",
                "saved exercise answers;",
                "scores and results from course activities and checks;",
                "form submissions;",
                "records showing that you have acknowledged applicable Course Use & Intellectual Property conditions."
            ]
        },
        {
            "type": "paragraph",
            "text": "Authorised administrators may access individual learning records where necessary to provide and administer the course."
        },
        {
            "type": "heading",
            "text": "Certificate information"
        },
        {
            "type": "paragraph",
            "text": "When you complete an eligible course and request a Certificate of Completion, we may process:"
        },
        {
            "type": "list",
            "items": [
                "the name you choose to appear on the certificate;",
                "the course completed;",
                "course completion date;",
                "certificate issue date;",
                "certificate identifier."
            ]
        },
        {
            "type": "paragraph",
            "text": "This information is used to generate your personalised certificate, make it available through your account and maintain a record of certificates issued."
        },
        {
            "type": "heading",
            "text": "Purchase information"
        },
        {
            "type": "paragraph",
            "text": "For purchases of self-paced digital products, we may process:"
        },
        {
            "type": "list",
            "items": [
                "the product purchased;",
                "price and currency;",
                "discounts or promotional codes;",
                "payment status;",
                "transaction and customer references;",
                "invoice information;",
                "refunds and other payment adjustments."
            ]
        },
        {
            "type": "paragraph",
            "text": "Payment-provider notifications and transaction references may be retained where necessary to process purchases correctly, investigate payment issues and maintain financial records."
        },
        {
            "type": "paragraph",
            "text": "We do not store full payment-card numbers or card security codes in the course database."
        },
        {
            "type": "heading",
            "text": "Feedback and reviews"
        },
        {
            "type": "paragraph",
            "text": "If you leave feedback, we may process:"
        },
        {
            "type": "list",
            "items": [
                "your course rating;",
                "optional written review;",
                "date of submission;",
                "whether you have chosen to allow the review to be published;",
                "moderation or approval status."
            ]
        },
        {
            "type": "paragraph",
            "text": "Leaving a review is voluntary and is not required in order to receive a certificate or continue accessing your course."
        },
        {
            "type": "heading",
            "text": "Technical information"
        },
        {
            "type": "paragraph",
            "text": "The website may process technical information required to operate, secure and troubleshoot the service, including:"
        },
        {
            "type": "list",
            "items": [
                "IP address;",
                "browser and device information;",
                "authentication logs;",
                "server or operational logs;",
                "browser storage used for sign-in and preferences."
            ]
        },
        {
            "type": "heading",
            "text": "3. How we use your information"
        },
        {
            "type": "paragraph",
            "text": "We use personal information to:"
        },
        {
            "type": "list",
            "items": [
                "create and manage user accounts;",
                "authenticate users and protect access to purchased courses;",
                "apply lesson prerequisites and course access rules;",
                "save learning activity, answers, scores and progress;",
                "display your learning history and course completion status;",
                "generate and make available personalised Certificates of Completion;",
                "process digital-product purchases and refunds;",
                "reconcile payment-provider notifications;",
                "maintain transaction and accounting records;",
                "resolve account, technical and payment problems;",
                "administer course feedback and reviews;",
                "publish a review only where you have chosen to allow publication and it has been approved;",
                "maintain security and investigate suspected misuse;",
                "comply with applicable legal, tax, accounting and regulatory obligations."
            ]
        },
        {
            "type": "heading",
            "text": "4. Lawful bases for processing"
        },
        {
            "type": "paragraph",
            "text": "Under UK data protection law, we rely on different lawful bases depending on why personal information is being used."
        },
        {
            "type": "heading",
            "text": "Performance of a contract"
        },
        {
            "type": "paragraph",
            "text": "We rely on performance of a contract where processing is necessary to:"
        },
        {
            "type": "list",
            "items": [
                "create and manage your course account;",
                "provide purchased digital products;",
                "save learning progress;",
                "generate course certificates;",
                "process purchases and provide course access;"
            ]
        },
        {
            "type": "heading",
            "text": "Legal obligations"
        },
        {
            "type": "paragraph",
            "text": "We may retain or process certain information where this is necessary to comply with applicable legal obligations, including tax, accounting and regulatory recordkeeping requirements."
        },
        {
            "type": "heading",
            "text": "Legitimate interests"
        },
        {
            "type": "paragraph",
            "text": "We may rely on legitimate interests for purposes such as:"
        },
        {
            "type": "list",
            "items": [
                "maintaining the security and reliability of the website;",
                "preventing misuse;",
                "troubleshooting technical problems;",
                "providing support;",
                "maintaining proportionate learning and course-participation analytics;",
                "understanding how courses are used and improving course delivery."
            ]
        },
        {
            "type": "heading",
            "text": "Consent"
        },
        {
            "type": "paragraph",
            "text": "We rely on your consent where you choose to allow an optional course review to be displayed publicly."
        },
        {
            "type": "paragraph",
            "text": "You may withdraw that consent at any time by contacting us."
        },
        {
            "type": "heading",
            "text": "5. Providers and other recipients"
        },
        {
            "type": "paragraph",
            "text": "We use third-party providers where necessary to operate the website and provide products."
        },
        {
            "type": "heading",
            "text": "Auth0"
        },
        {
            "type": "paragraph",
            "text": "Auth0 provides account authentication and sign-in functionality."
        },
        {
            "type": "paragraph",
            "text": "Auth0 processes information required for account registration, authentication and account security. If you choose to sign in using another external identity provider, that provider may also process information according to its own privacy terms."
        },
        {
            "type": "paragraph",
            "text": "The course database receives relevant identity and profile information but does not store your authentication password."
        },
        {
            "type": "heading",
            "text": "Paddle"
        },
        {
            "type": "paragraph",
            "text": "Paddle acts as Merchant of Record for purchases of self-paced digital products."
        },
        {
            "type": "paragraph",
            "text": "Payment information is entered through Paddle's checkout environment. The website receives and stores relevant transaction, customer and payment-status references required to provide access to purchased products."
        },
        {
            "type": "paragraph",
            "text": "Paddle also processes personal information for its own payment, tax, fraud-prevention and regulatory purposes under its own privacy notice. Paddle describes its Merchant of Record business and relevant Paddle entities as controllers in its current privacy documentation."
        },
        {
            "type": "heading",
            "text": "Hosting, database, email and infrastructure providers"
        },
        {
            "type": "paragraph",
            "text": "Service providers involved in hosting the website, storing application data, sending email and maintaining the technical infrastructure may process personal information where necessary to provide those services."
        },
        {
            "type": "heading",
            "text": "Authorised administrators"
        },
        {
            "type": "paragraph",
            "text": "Authorised administrators may access information where necessary to manage:"
        },
        {
            "type": "list",
            "items": [
                "learners and course access;",
                "learning progress;",
                "certificates;",
                "feedback and reviews;",
                "purchases;",
                "support and technical issues;",
                "financial administration."
            ]
        },
        {
            "type": "heading",
            "text": "Legal and professional recipients"
        },
        {
            "type": "paragraph",
            "text": "Personal information may also be disclosed to professional advisers, regulators, courts or other competent authorities where this is reasonably necessary to comply with a legal obligation or establish, exercise or defend legal claims."
        },
        {
            "type": "heading",
            "text": "6. Product reviews"
        },
        {
            "type": "paragraph",
            "text": "After completing a product, you may be invited to leave a rating and an optional written review."
        },
        {
            "type": "paragraph",
            "text": "Your rating and review are associated with your account internally so that feedback can be administered appropriately."
        },
        {
            "type": "paragraph",
            "text": "A review is displayed publicly only if:"
        },
        {
            "type": "list",
            "items": [
                "you choose to allow it to be shared; and",
                "it is approved for publication."
            ]
        },
        {
            "type": "paragraph",
            "text": "The public version of a review may display:"
        },
        {
            "type": "list",
            "items": [
                "the course;",
                "rating;",
                "review text;",
                "date;",
                "the label “Course graduate”."
            ]
        },
        {
            "type": "paragraph",
            "text": "Your account name and email address are not intended to be shown as part of the public review presentation."
        },
        {
            "type": "paragraph",
            "text": "However, any personal information that you voluntarily include within the review text itself may become publicly visible."
        },
        {
            "type": "paragraph",
            "text": "You can withdraw your permission for publication at any time by contacting us. Withdrawal will stop future publication but does not affect processing that lawfully took place before consent was withdrawn."
        },
        {
            "type": "heading",
            "text": "7. AI assistance"
        },
        {
            "type": "paragraph",
            "text": "AI-generated explanations or feedback would be provided for learning support only and would not constitute an external qualification, formal assessment or admissions decision."
        },
        {
            "type": "heading",
            "text": "8. Browser storage and cookies"
        },
        {
            "type": "paragraph",
            "text": "The application uses browser storage where necessary for functions such as:"
        },
        {
            "type": "list",
            "items": [
                "authentication;",
                "maintaining user preferences;",
                "remembering the selected theme or interface layout;",
                "temporarily remembering a product selected for purchase while you sign in;",
                "other functional settings used by the application."
            ]
        },
        {
            "type": "paragraph",
            "text": "Clearing browser storage may sign you out or reset your preferences. It does not automatically delete course progress, purchase information or other records held on the server."
        },
        {
            "type": "paragraph",
            "text": "Authentication, payment and infrastructure providers may also use cookies or similar technologies as part of the services they provide."
        },
        {
            "type": "heading",
            "text": "9. How long we keep information"
        },
        {
            "type": "paragraph",
            "text": "We keep personal information only for as long as reasonably necessary for the purpose for which it was collected, taking into account legal, contractual, administrative and security requirements."
        },
        {
            "type": "paragraph",
            "text": "The criteria used include the following:"
        },
        {
            "type": "heading",
            "text": "Account and learning records"
        },
        {
            "type": "paragraph",
            "text": "These are retained while your account and course access remain active and may be retained afterwards where reasonably necessary for learner support, account administration, dispute resolution, security or recordkeeping."
        },
        {
            "type": "heading",
            "text": "Certificate records"
        },
        {
            "type": "paragraph",
            "text": "Certificate records may be retained so that certificates that have been issued can continue to be accessed, administered or verified."
        },
        {
            "type": "heading",
            "text": "Purchase and financial records"
        },
        {
            "type": "paragraph",
            "text": "Financial and transaction records may be retained for the period required by applicable tax, accounting or legal obligations, including after an account has been closed."
        },
        {
            "type": "heading",
            "text": "Reviews"
        },
        {
            "type": "paragraph",
            "text": "Reviews and associated moderation records may be retained while they are needed for course feedback and administration."
        },
        {
            "type": "paragraph",
            "text": "Where publication is based on consent, the public review will be removed if that consent is withdrawn, subject to any information that must lawfully be retained for another purpose."
        },
        {
            "type": "heading",
            "text": "Technical and security records"
        },
        {
            "type": "paragraph",
            "text": "Technical and security logs are retained for a period appropriate to troubleshooting, operational reliability, fraud prevention and security."
        },
        {
            "type": "paragraph",
            "text": "Backup copies may remain for a limited additional period until they are overwritten or deleted in accordance with the relevant backup cycle."
        },
        {
            "type": "heading",
            "text": "10. International processing"
        },
        {
            "type": "paragraph",
            "text": "Some providers involved in authentication, payment processing, hosting, communications or infrastructure may process personal information outside the United Kingdom."
        },
        {
            "type": "paragraph",
            "text": "Where UK data protection rules treat such processing as a restricted international transfer, appropriate legal protections are used as required."
        },
        {
            "type": "paragraph",
            "text": "Depending on the provider and destination, these may include:"
        },
        {
            "type": "list",
            "items": [
                "UK adequacy regulations;",
                "the UK International Data Transfer Agreement;",
                "the UK Addendum to the EU Standard Contractual Clauses;",
                "another legally permitted safeguard or exception."
            ]
        },
        {
            "type": "paragraph",
            "text": "ICO guidance confirms that restricted transfers must normally be covered by adequacy regulations, appropriate safeguards or an applicable exception."
        },
        {
            "type": "paragraph",
            "text": "Where appropriate safeguards are used, UK law may also require an assessment of whether the transferred information continues to receive an adequate standard of protection."
        },
        {
            "type": "paragraph",
            "text": "You can contact us if you would like further information about the safeguards relevant to your personal information."
        },
        {
            "type": "heading",
            "text": "11. Your rights"
        },
        {
            "type": "paragraph",
            "text": "Depending on the circumstances and applicable law, you may have the right to:"
        },
        {
            "type": "list",
            "items": [
                "request access to the personal information we hold about you;",
                "ask us to correct inaccurate or incomplete information;",
                "request deletion of personal information;",
                "request restriction of processing;",
                "receive certain information in a portable format;",
                "object to certain types of processing;",
                "withdraw consent where processing relies on consent."
            ]
        },
        {
            "type": "paragraph",
            "text": "These rights are subject to the conditions and exceptions provided by applicable data protection law. For example, we may need to retain some financial information even after an account is closed where this is required by law."
        },
        {
            "type": "paragraph",
            "text": "You can edit supported profile information through your account."
        },
        {
            "type": "paragraph",
            "text": "For other requests, please contact:"
        },
        {
            "type": "paragraph",
            "text": "olgapopivnenko35@gmail.com"
        },
        {
            "type": "paragraph",
            "text": "We may request reasonable information to confirm your identity before responding to a rights request."
        },
        {
            "type": "heading",
            "text": "Your right to object"
        },
        {
            "type": "paragraph",
            "text": "Where we rely on legitimate interests, you may object to the use of your personal information."
        },
        {
            "type": "paragraph",
            "text": "This includes the use of learning records for legitimate-interest-based service analytics."
        },
        {
            "type": "paragraph",
            "text": "If you object, please explain your circumstances so that we can consider the request and determine whether there are compelling legitimate grounds to continue the processing or another lawful reason why the information must be retained or used."
        },
        {
            "type": "paragraph",
            "text": "ICO guidance recognises the right to object to processing based on legitimate interests and requires this right to be brought clearly and separately to people's attention."
        },
        {
            "type": "heading",
            "text": "12. Complaints"
        },
        {
            "type": "paragraph",
            "text": "If you have concerns about how your personal information is being used, you may contact us first so that we have an opportunity to address them."
        },
        {
            "type": "paragraph",
            "text": "You also have the right to complain to the UK Information Commissioner's Office (ICO)."
        },
        {
            "type": "paragraph",
            "text": "If data protection law in another jurisdiction applies to your information, you may also have the right to contact the relevant local supervisory authority."
        },
        {
            "type": "paragraph",
            "text": "You are not required to contact us before making a complaint to a supervisory authority."
        },
        {
            "type": "heading",
            "text": "13. Security"
        },
        {
            "type": "paragraph",
            "text": "We use technical and organisational measures intended to protect personal information, including authentication and access controls that restrict learner and administrative functions."
        },
        {
            "type": "paragraph",
            "text": "You should keep your own account credentials secure and contact us promptly if you believe your account has been accessed without permission."
        },
        {
            "type": "paragraph",
            "text": "Although reasonable measures are taken to protect personal information, no online system can guarantee complete security."
        },
        {
            "type": "heading",
            "text": "14. Changes to this Privacy Policy"
        },
        {
            "type": "paragraph",
            "text": "We may update this Privacy Policy when the website, courses or data-processing arrangements change, or where changes are required by law."
        },
        {
            "type": "paragraph",
            "text": "The date at the top of this page will show when the Privacy Policy was last updated."
        },
        {
            "type": "paragraph",
            "text": "Where a change materially affects how personal information is used, we will take reasonable steps to bring the updated information to users' attention."
        }
    ]
};
